document.addEventListener('click', function (e) {
  // 找到触发的按钮或链接
  const btn = e.target.closest('[data-copy-code], a[href^="#copy-"]');
  if (!btn) return;

  e.preventDefault();

  // 读取 promo code
  let code = btn.getAttribute('data-copy-code');
  if (!code && btn.getAttribute('href')) {
    code = btn.getAttribute('href').replace('#copy-', '');
  }
  if (!code) return;

  code = code.trim().toUpperCase();

  // 复制到剪贴板
  navigator.clipboard.writeText(code).then(() => {
    // 清除旧的 toast（防止重复）
    const oldToast = document.querySelector('.promo-copy-toast');
    if (oldToast) oldToast.remove();

    // 计算位置
    const btnRect = btn.getBoundingClientRect();

    // 创建 toast
    const toast = document.createElement('div');
    toast.className = 'promo-copy-toast';
    toast.textContent = 'Copied!';
    toast.setAttribute('aria-live', 'polite');

    // 定位：按钮正上方一点点
    toast.style.position = 'fixed';
    toast.style.left = `${btnRect.left + btnRect.width / 2}px`;
    toast.style.top = `${btnRect.top - 10}px`;   // 👈 调这里（-8 / -12 / -16）
    toast.style.transform = 'translate(-50%, -100%)';
    toast.style.zIndex = '999999';
    toast.style.pointerEvents = 'none';

    // 插入页面
    document.body.appendChild(toast);

    // 自动消失
    setTimeout(() => {
      toast.remove();
    }, 1200);
  });
});
